import {defineStore} from 'pinia';
import {ref} from 'vue';

export const useUserStore = defineStore(
    'userStore',
    () => {
        const token = ref<string>('');
        const userInfo = ref<Recordable>();

        function setToken(val: string) {
            token.value = val;
        }

        function resetStore() {
            token.value = '';
            userInfo.value = {};
        }

        return {
            token,
            setToken,
            userInfo,
            resetStore,
        };
    },
);
